import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, Table, TableHead, TableCell, TableBody, TableRow, ButtonBase, } from '@material-ui/core';
import MButtonTwo from '../../view/MTabsButton';
import MDivider from '../../view/MDivider';
import Apis from '../../../network/Apis';
import MSectionHeader from '../../view/MSectionHeader';
import { MBasketTableHeader } from '.';
import MBasketTableItem from './MBasketTableItem';
import MBasketChartItem from './MBasketChartItem';

class MovieStateBasketStatistics extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            value: 1,
            stats: [],
            ranks: [],
        };
        console.log('MovieStateBasketStatistics', props);
    }

    componentDidMount() {
        this.getBasketballRealtimeData();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getBasketballRealtimeData = async () => {
        let { matchId, matchType } = this.props.match.params;
        const { data } = this.props;
        if (matchType == 0) {
            matchType = data.match_type;
        }
        if (matchId == 0) {
            matchId = data.match_id;
        }
        let result = await Apis.encryptionDetailLive(matchType, matchId);
        console.log('MovieStateBasketStatistics', result);
        if (result.code == 200) {
            let ranks = this.getRanking(result.data.players);
            this.setState({ stats: result.data.stats, ranks: ranks })
        }
    }

    getType(type) {
        const BASKETDATA = ['', '3分球进球数', '2分球进球数', '罚球进球数', '剩余暂停数', '犯规数', '罚球命中率', '总暂停数'];
        return BASKETDATA[type] ? BASKETDATA[type] : '';
    }

    getRanking(data) {
        if (!data) return [];
        let homePlayers = [];
        let awayPlayers = [];
        if (data[0]) {
            for (let i = 0; i < data[0].length; i++) {
                homePlayers.push(data[0][i]);
            }
        }
        if (data[1]) {
            for (let i = 0; i < data[1].length; i++) {
                awayPlayers.push(data[1][i]);
            }
        }

        let result = [];
        result.push(this.putRanking({}, '得分', 13, homePlayers, awayPlayers));
        result.push(this.putRanking({}, '篮板', 6, homePlayers, awayPlayers));
        result.push(this.putRanking({}, '助攻', 7, homePlayers, awayPlayers));
        result.push(this.putRanking({}, '抢断', 8, homePlayers, awayPlayers));
        result.push(this.putRanking({}, '盖帽', 9, homePlayers, awayPlayers));
        return result;
    }

    putRanking(item, title, index, homePlayers, awayPlayers) {
        item.title = title;
        this.maxItem(item, index, homePlayers, awayPlayers);
        return item;
    }

    maxItem(obj, index, homePlayers, awayPlayers) {
        let maxScore = -1;
        for (let i = 0; i < homePlayers.length; i++) {
            let item = homePlayers[i][6];
            if (item) {
                let items = item.split('^');
                if (items && items[1] && items[index]) {
                    if (Number(items[index]) > maxScore) {
                        obj.homeName = homePlayers[i][1];
                        obj.homeScore = items[index];
                        maxScore = Number(items[index]);
                    }
                }
            }
        }

        maxScore = -1;
        for (let i = 0; i < awayPlayers.length; i++) {
            let item = awayPlayers[i][6];
            if (item) {
                let items = item.split('^');
                if (items && items[1] && items[index]) {
                    if (Number(items[index]) > maxScore) {
                        obj.awayName = awayPlayers[i][1];
                        obj.awayScore = items[index];
                        maxScore = Number(items[index]);
                    }
                }
            }
        }
    }

    render() {
        const { classes } = this.props;
        const { data } = this.props.location;
        const { stats, ranks } = this.state;
        console.log('MovieStateBasketStatistics====>', data);
        return (
            <Grid container direction='column' alignItems='center' justify='center' className={classes.root}>
                <MSectionHeader title='各项最高' />
                <MBasketTableHeader title={data ? data.home_name : ''} subtitle={data ? data.away_name : ''} />
                <Grid container direction='column' alignItems='center' justify='center' style={{ marginLeft: 8, marginRight: 8, width: 'calc(100vw - 16px)' }}>
                    {
                        ranks.map((item, i) => (
                            <MBasketTableItem
                                key={i}
                                title={item.homeName}
                                subtitle={item.awayName}
                                midtitle={item.title}
                                score1={item.homeScore}
                                score2={item.awayScore}
                                backgroundColor={i % 2 == 0 ? '#FFF' : '#F7F7F7'}
                            />
                        ))
                    }
                </Grid>
                <MSectionHeader title='球队统计' />
                <Grid container direction='column' alignItems='center' justify='center' style={{ marginLeft: 8, marginRight: 8, width: 'calc(100vw - 16px)' }}>
                    {
                        stats && stats.map((item, i) => (
                            <MBasketChartItem key={i} score1={item[1]} score2={item[2]} midtitle={this.getType(item[0])} allscore1={item[1] + item[2]} allscore2={item[1] + item[2]} />
                        ))
                    }
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        borderRadius: 10,
        backgroundColor: '#FFF'
    },


}))(MovieStateBasketStatistics));